/**
* @author 阿佑[ayooooo@petalmail.com]
* @date 2022/4/16 18:31
* @description
*   OnlyApp.vue of WeTrade
*/
<template>
<PageWithHeader>
  <template #title>Get WeTrade Mobile App</template>

  <div class="t-center">
    <t path="getapp_2" as="p" class="f-xl f-bold" style="padding: 50px 0">Best mobile trading platform</t>

    <a target="_blank" href="https://apps.apple.com/us/app/wetrade-market-data-and-news/id1604139836">
      <Pic src="invite/apple_store" width="145" height="78" />
    </a>
    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.wtmob.app">
      <Pic src="invite/google_play" width="145" height="78" class="ml-20" />
    </a>

    <div class="df-middle t-left" style="padding: 50px 0">
      <Pic src="invite/shield" width="40" height="40" class="v-middle" />
      <t as="p" path="getapp_3" class="f-lg ml-10">For the safety of funds, the withdrawal is only on mobile app</t>
    </div>
    <div>
      <Pic src="invite/phoneV2" width="325" />
    </div>
  </div>
</PageWithHeader>
</template>

<script lang="ts">
import Pic from '@/components/Pic.vue'
import PageWithHeader from '@/provider/PageWithHeader.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GetApp',
  components: { Pic, PageWithHeader },
})
</script>

<style scoped>
</style>
